module.exports = __webpack_public_path__ + "static/media/document.a8eb7877.svg";